import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { TooltipButton } from "@/v2/components/ui/tooltip-button";

/** Outline icon button with a tooltip — the shared unit of the Entries toolbar. */
export function IconButton({
	icon: Icon,
	iconNode,
	label,
	onClick,
	disabled,
}: {
	icon?: LucideIcon;
	iconNode?: ReactNode;
	label: string;
	onClick?: () => void;
	disabled?: boolean;
}) {
	return (
		<TooltipButton
			variant="outline"
			size="icon"
			aria-label={label}
			onClick={onClick}
			disabled={disabled}
			className="group"
			tooltip={label}
		>
			{iconNode ?? (Icon ? <Icon /> : null)}
		</TooltipButton>
	);
}
